import { takeLatest, fork, put, select } from "redux-saga/effects";

import ApiClient from "../../../api/ApiClient";
import { canAccessPaymentInvoices } from "../../../lib/payment/canAccessPaymentInvoices";
import { actions as alertActions } from "../alerts";
import { getUserData } from "../auth/login/selector";
import { getTransactionHistoryRoutine } from "../transactionHistory";
import {
  createPaymentInvoiceRoutine,
  fetchPaymentInvoicesRoutine,
  PAYMENT_INVOICES_DEFAULT_LIMIT
} from "./index";

function* fetchPaymentInvoices({ payload = {} } = {}) {
  const userData = yield select(getUserData);

  if (!canAccessPaymentInvoices(userData)) {
    yield put(
      fetchPaymentInvoicesRoutine.failure(new Error("EMAIL_NOT_VALIDATED"))
    );
    return;
  }

  const {
    offset = 0,
    limit = PAYMENT_INVOICES_DEFAULT_LIMIT,
    append
  } = payload;

  try {
    const response = yield ApiClient.get({
      urlPath: "app.invoices.invoicesList",
      variables: {
        offset,
        limit
      }
    });

    yield put(
      fetchPaymentInvoicesRoutine.success({
        ...(response?.data ?? {}),
        append: !!append
      })
    );
  } catch (error) {
    yield put(fetchPaymentInvoicesRoutine.failure(error));
  }
}

function* createPaymentInvoice({ payload }) {
  const paymentId = payload?.payment_id;

  try {
    yield ApiClient.post({
      urlPath: "app.invoices.createInvoice",
      data: {
        payment_id: paymentId
      }
    });

    yield put(
      alertActions.addSuccessAlert({
        title: "transaction_history_create_invoice_success"
      })
    );
    yield put(createPaymentInvoiceRoutine.success());
    yield put(
      fetchPaymentInvoicesRoutine({
        offset: 0,
        limit: PAYMENT_INVOICES_DEFAULT_LIMIT,
        silent: true
      })
    );
    yield put(getTransactionHistoryRoutine({ silent: true }));
  } catch (error) {
    const apiError = error?.response?.data?.error;

    yield put(
      alertActions.addErrorAlert({
        title:
          typeof apiError === "string" && apiError.length
            ? apiError
            : "transaction_history_create_invoice_error"
      })
    );
    yield put(createPaymentInvoiceRoutine.failure(error));
  }
}

function* watchFetchPaymentInvoices() {
  yield takeLatest(fetchPaymentInvoicesRoutine.TRIGGER, fetchPaymentInvoices);
}

function* watchCreatePaymentInvoice() {
  yield takeLatest(createPaymentInvoiceRoutine.TRIGGER, createPaymentInvoice);
}

export default [
  fork(watchFetchPaymentInvoices),
  fork(watchCreatePaymentInvoice)
];
